export default __webpack_public_path__ + "static/media/front_b.97a98280.jpg";